module.exports = __webpack_public_path__ + "static/media/desgin-480x360@2x.88960fa2.png";